import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Check your inbox for a reset link.');
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F3] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/">
            <h1 className="text-3xl font-light tracking-tight mb-2" style={{ fontFamily: 'Spectral, serif' }}>
              Stable Stationary
            </h1>
          </Link>
          <p className="text-sm text-[#737373]">Reset your password</p>
        </div>

        <div className="bg-white border border-[#E5E0D8] rounded-md p-8 shadow-[2px_2px_0px_rgba(26,26,26,0.08)]">
          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-sent-view">
              <p className="text-[#1A1A1A]" style={{ fontFamily: 'Spectral, serif', fontSize: '18px' }}>
                Check your inbox.
              </p>
              <p className="text-sm text-[#737373]">
                If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. It expires in 1 hour.
              </p>
              <Link to="/login" className="text-[#B94A3E] hover:underline text-sm" data-testid="forgot-back-to-login">
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-testid="forgot-form">
              <p className="text-sm text-[#737373] mb-4">
                Enter your email and we'll send you a link to reset your password.
              </p>
              <div className="space-y-4">
                <div>
                  <Label htmlFor="email" className="label-text">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="mt-2 border-[#E5E0D8] focus:ring-[#B94A3E]"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full bg-[#B94A3E] hover:bg-[#9d3e33] text-white"
                  disabled={loading}
                  data-testid="forgot-submit-btn"
                >
                  {loading ? 'Sending…' : 'Send reset link'}
                </Button>
              </div>
              <div className="mt-6 text-center text-sm">
                <Link to="/login" className="text-[#B94A3E] hover:underline" data-testid="forgot-login-link">
                  Back to sign in
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
